import {useQuery} from "@tanstack/react-query";
import {CommerceApi, Token} from "@devour/client";
import getConfig from "@/utils/getConfig";
import {StripePaymentMethodObject} from "@/types/Stripe";

interface StripePaymentMethodListResponse {
    paymentMethods: Array<StripePaymentMethodObject>;
}

async function fetchStripePaymentMethodList(): Promise<StripePaymentMethodListResponse> {
    return await new CommerceApi(getConfig()).getStripePaymentMethods() as StripePaymentMethodListResponse;
}

function stripePaymentMethodListQuery(fullToken: Token) {
    return {
        queryKey: [
            "stripe-payment-method-list",
            fullToken?.id,
        ],
        queryFn: () => fetchStripePaymentMethodList(),
        staleTime: 24 * 60 * 60000,
        enabled: !!fullToken,
    } as const;
}

export function useGetStripePaymentMethodList(fullToken: Token) {
    return useQuery(stripePaymentMethodListQuery(fullToken));
}